import { Injectable } from '@angular/core';
import { Evaluation, EvaluationData } from "../../common/models/evaluation";
import { Observable } from "rxjs";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { CurrentUser } from "../../common/providers/current-user";
import { map } from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class EvaluationProvider {
    constructor(
      private api: ApiBaseService,
      private _currentUser: CurrentUser
    ) {}

    /**
     * Find all Evaluation
     */
    public findAll(): Observable<Evaluation[]> {
      return this.api.call('GET', 'nosync/common-data/evaluations', {}, this._currentUser.getAccessToken()).pipe(
        map((data: EvaluationData[]) => {
          return Evaluation.fromAPIList(data);
        })
      );
    }
}
